import Marquee from "react-fast-marquee";

const ITEMS = ["PERFORMANCE GEAR", "GRIND NEVER STOPS", "ENGINEERED FOR THE ELITE", "DAFITEXCHANGE"];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-white/10 bg-[#D3FF24] py-4 md:py-5 overflow-hidden">
      <Marquee speed={35} gradient={false}>
        {ITEMS.map((t) => (
          <span key={t} className="flex items-center">
            <span className="font-display font-black tracking-tight text-[#0A0A0C] text-xl md:text-3xl px-6">
              {t}
            </span>
            <span className="text-[#0A0A0C]/50 text-xl md:text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
